import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <h2>Sorry, the page you are looking for could not be found.</h2>
      <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
    </div>
  );
};

export default NotFound;